export { default } from '@esentai/core/features/parkingWhitelistGroups/api';
